<template>

	<div class="g-searchspring__listing g-product-list">
		<div v-if="pagination.totalResults > 0" class="g-layout u-grids-2 u-grids-3--m u-grids-4--l">
			<template v-for="(result, index) in results">
				<inline-banner v-if="result.isInlineBanner" :key="index" :result="result" />
				<product-card v-else :key="index" :result="result"></product-card>
			</template>
		</div>

		<div v-if="pagination.totalResults === 0" class="g-search-results-empty">
			<div class="g-search-results-empty__message">
				No products matched your search criteria.
			</div>

			<div class="g-search-results-empty__suggestion">
				<div v-if="didYouMean.query" class="g-search-results-empty__suggestion-content">
					Did you mean <a class="g-search-results-empty__suggestion-link" :href="`/search-results.html?Search=${didYouMean.query}`" :title="didYouMean.query">{{ didYouMean.query }}</a>?
				</div>
				<div v-else class="g-search-results-empty__suggestion-content">
					Try a different search or go back to <a class="g-search-results-empty__suggestion-link" href="/" title="Back to home">Home</a>.
				</div>
			</div>
		</div>
	</div>

</template>

<script>

	import InlineBanner from './InlineBanner';
	import ProductCard from './ProductCard';

	export default {
		props: {
			results: {
				default() {
					return {};
				}
			},
			pagination: {
				default() {
					return {};
				}
			},
			merchandising: {
				default() {
					return {};
				}
			},
			didYouMean: {
				default() {
					return {};
				}
			}
		},
		components: {
			'inline-banner': InlineBanner,
			'product-card': ProductCard
		}
	}

</script>
